import React from 'react';
import { connect } from 'react-redux';
import { clearGlobalError, hideErrorModal } from '../../../actions/globalActions';
import ErrorPopup from '../../ErrorPopup/ErrorPopup';
import { SectionContent } from '../../commonStyles';
import { sessionFlush } from '../../../utils/sessionUtil';
import {
    selectfallbackError,
    selectfallbackMessage,
    selectisLogout,
    selectprimaryCtaLabel,
    selectfallbackTitle,
    selectfallbackRedirect,
    selectisDirectlogout,
    selectisRedirectfirst
} from '../../../selectors/globalSelectors';
import history from '../../../history/history';


export const Title = ({ isLogout, title }) => (<p className={!isLogout ? "fallback-error-heading" : null}>
    {
        title ? title : 'Something went wrong at our end'
    }
</p>)

const handleOnClick = (isLogout, hideModal, redirect, isRedirectfirst) => {
    if (isLogout) {
        sessionFlush()
    }
    else {
        hideModal()
    }
    if (!isRedirectfirst && redirect) {
        history.push(redirect)
    }
}

export const FallBackError = (props) => {
    const { visible, message, clearError, primaryCtaLabel = "LOGOUT", isLogout = true, hideModal, title, redirect, isDirectlogout, isRedirectfirst } = props;
    if (isDirectlogout && redirect && window.auth0) {
        window.auth0.logout({ returnTo: redirect });
        return '';
    } else if (isRedirectfirst && redirect) {
        history.push(redirect);
    }
    return <ErrorPopup
        show={visible}
        title={<Title isLogout={isLogout} title={title} />}
        primaryCtaLabel={primaryCtaLabel}
        primaryCta={() => {
            handleOnClick(isLogout, hideModal, redirect, isRedirectfirst)
        }}
        afterClose={clearError}
    >
        <SectionContent>{message ? message : "We're sorry. We are facing an issue in completing your request. Please logout and try again. If problem persists, please contact us."}</SectionContent>
    </ErrorPopup>
}


const mapStateToProps = (state) => ({
    isLogout: selectisLogout(state.toJS()),
    primaryCtaLabel: selectprimaryCtaLabel(state.toJS()),
    visible: selectfallbackError(state.toJS()),
    message: selectfallbackMessage(state.toJS()),
    title: selectfallbackTitle(state.toJS()),
    redirect: selectfallbackRedirect(state.toJS()),
    isDirectlogout: selectisDirectlogout(state.toJS()),
    isRedirectfirst: selectisRedirectfirst(state.toJS())
});

export const mapDispatchToProps = (dispatch) => ({
    clearError: () => dispatch(clearGlobalError()),
    hideModal: () => dispatch(hideErrorModal())
})
export default connect(mapStateToProps, mapDispatchToProps)(FallBackError);